module.exports = __webpack_public_path__ + "static/media/clutch_logo.cccd590d.png";